/* Upload this file to Assets as: section-subtle-radiance.js */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sr-product').forEach(initSubtleRadianceProduct);
});

function initSubtleRadianceProduct(root) {
  var productHandle = root.dataset.productHandle;
  var form = root.querySelector('#sr-product-form');
  var variantInput = root.querySelector('[data-variant-id-input]');
  var qtyInput = root.querySelector('[data-qty-input]');
  var addBtn = root.querySelector('[data-add-to-cart]');
  var addBtnText = root.querySelector('[data-add-to-cart-text]');
  var buyNowBtn = root.querySelector('[data-buy-now]');
  var priceEl = root.querySelector('[data-price]');
  var comparePriceEl = root.querySelector('[data-compare-price]');
  var priceOffEl = root.querySelector('[data-price-off]');
  var stockLine = root.querySelector('[data-stock-line]');
  var selectedLabel = root.querySelector('[data-selected-option-label]');

  var productData = null;

  fetch('/products/' + productHandle + '.js')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      productData = data;
      // Apply thumbnail/image filtering for whichever variant is selected on page load
      var initialVariant = findVariantById(variantInput.value);
      if (initialVariant) updateGalleryForVariant(initialVariant);
    });

  // All shade/option values across the product, used to tell "variant-specific image"
  // apart from "general product photo" by comparing against the image's alt text.
  var optionValuesEl = root.querySelector('[data-option-values]');
  var allOptionValues = [];
  if (optionValuesEl) {
    try {
      allOptionValues = JSON.parse(optionValuesEl.textContent).map(normalize).filter(Boolean);
    } catch (e) {
      allOptionValues = [];
    }
  }

  function normalize(str) {
    return (str || '').trim().toLowerCase();
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toFixed(2);
  }

  function findVariantById(id) {
    if (!productData) return null;
    return productData.variants.find(function (v) { return String(v.id) === String(id); });
  }

  // Show only thumbnails/images whose alt text either isn't tied to any shade
  // (general product photography — always shown) or matches the selected
  // variant's title / option value (e.g. alt="Deep Tan" shows only for that shade).
  function filterGalleryByVariant(variant) {
    var variantTitle = normalize(variant.title);
    var variantOptionValues = [variant.option1, variant.option2, variant.option3]
      .filter(Boolean)
      .map(normalize);

    function shouldShow(altText) {
      var alt = normalize(altText);
      if (!alt) return true; // no alt tag -> treat as a generic photo, always show
      var isVariantSpecific = allOptionValues.indexOf(alt) !== -1;
      if (!isVariantSpecific) return true; // alt doesn't reference any shade -> generic photo
      return alt === variantTitle || variantOptionValues.indexOf(alt) !== -1;
    }

    var mainImages = root.querySelectorAll('.sr-gallery__main-image');
    var thumbs = root.querySelectorAll('.sr-gallery__thumb');

    mainImages.forEach(function (img) {
      img.style.display = shouldShow(img.dataset.mediaAlt) ? '' : 'none';
    });
    thumbs.forEach(function (thumb) {
      thumb.style.display = shouldShow(thumb.dataset.mediaAlt) ? '' : 'none';
    });
  }

  function updateGalleryForVariant(variant) {
    if (!variant) return;

    filterGalleryByVariant(variant);

    var mainImages = root.querySelectorAll('.sr-gallery__main-image');
    var thumbs = root.querySelectorAll('.sr-gallery__thumb');

    // Prefer the variant's own featured image if it's currently visible,
    // otherwise fall back to the first visible image in the filtered set.
    var targetId = null;
    if (variant.featured_media) {
      var featuredImg = root.querySelector(
        '.sr-gallery__main-image[data-media-id="' + variant.featured_media.id + '"]'
      );
      if (featuredImg && featuredImg.style.display !== 'none') {
        targetId = variant.featured_media.id;
      }
    }
    if (targetId === null) {
      for (var i = 0; i < mainImages.length; i++) {
        if (mainImages[i].style.display !== 'none') {
          targetId = mainImages[i].dataset.mediaId;
          break;
        }
      }
    }

    mainImages.forEach(function (img) {
      img.classList.toggle('is-active', String(img.dataset.mediaId) === String(targetId));
    });
    thumbs.forEach(function (thumb) {
      thumb.classList.toggle('is-active', String(thumb.dataset.mediaId) === String(targetId));
    });
  }

  function selectVariant(variantId) {
    var variant = findVariantById(variantId);
    if (!variant) return;

    variantInput.value = variant.id;

    // price
    priceEl.textContent = formatMoney(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (comparePriceEl) {
        comparePriceEl.style.display = '';
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
      }
      if (priceOffEl) {
        priceOffEl.style.display = '';
        var offPct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        priceOffEl.textContent = '(' + offPct + '% OFF)';
      }
    } else {
      if (comparePriceEl) comparePriceEl.style.display = 'none';
      if (priceOffEl) priceOffEl.style.display = 'none';
    }

    // availability
    var available = variant.available;
    addBtn.disabled = !available;
    if (buyNowBtn) buyNowBtn.disabled = !available;
    addBtnText.textContent = available ? 'Add to Bag' : 'Sold Out';
    root.classList.toggle('is-sold-out', !available);

    if (stockLine) {
      stockLine.innerHTML = available
        ? '<span class="sr-dot sr-dot--green"></span>In stock · 24-Hour Dispatch · COD available · Free returns within 30 days'
        : '<span class="sr-dot sr-dot--red"></span>Currently unavailable in this shade';
    }

    if (selectedLabel) selectedLabel.textContent = variant.title;

    updateGalleryForVariant(variant);

    // reflect selected swatch
    root.querySelectorAll('.sr-swatch').forEach(function (sw) {
      sw.classList.toggle('is-selected', String(sw.dataset.variantId) === String(variant.id));
    });
  }

  // swatch click
  root.querySelectorAll('.sr-swatch').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-unavailable')) return;
      selectVariant(btn.dataset.variantId);
    });
  });

  // thumbnail click
  root.querySelectorAll('.sr-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mediaId = thumb.dataset.mediaId;
      root.querySelectorAll('.sr-gallery__main-image').forEach(function (img) {
        img.classList.toggle('is-active', String(img.dataset.mediaId) === String(mediaId));
      });
      root.querySelectorAll('.sr-gallery__thumb').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  });

  // quantity controls
  var minusBtn = root.querySelector('[data-qty-minus]');
  var plusBtn = root.querySelector('[data-qty-plus]');
  if (minusBtn) {
    minusBtn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, val - 1);
    });
  }
  if (plusBtn) {
    plusBtn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
  }

  // add to cart -> AJAX -> redirect to /cart ; buy now -> native checkout submit
  form.addEventListener('submit', function (e) {
    var isCheckout = e.submitter && e.submitter.name === 'checkout';
    if (isCheckout) return; // let the normal form submission go to /cart/add then checkout

    e.preventDefault();
    if (addBtn.disabled) return;

    addBtnText.textContent = 'Adding...';
    addBtn.disabled = true;

    var body = {
      id: variantInput.value,
      quantity: parseInt(qtyInput.value, 10) || 1
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        addBtnText.textContent = 'Add to Bag';
        addBtn.disabled = false;

        if (document.getElementById('cart-drawer') && window.CartDrawer) {
          window.CartDrawer.refresh().then(function () {
            window.CartDrawer.open();
          });
        } else {
          // Fallback if the cart drawer snippet isn't installed on this theme
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        addBtnText.textContent = 'Add to Bag';
        addBtn.disabled = false;
        alert(err.description || 'Could not add this item to your cart.');
      });
  });
}
